var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(this.user.photo_url)?_c('b-img-lazy',{staticClass:"rounded-circle",style:(_vm.imgStyle),attrs:{"src":this.getApiUrl(this.user.photo_url)}}):_c('NameCircle',{attrs:{"name":_vm.user.first_name,"size":this.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }